import React from 'react';

const Header = (props) => (
  <header className='header'>
    <div className='content'>
      <h1 className='header-text'>
        Henrik Lauritsen
        <br />
        Software developer, musician & craft beer enthusiast
      </h1>
    </div>
  </header>
);

export default Header;
